import {
    ActionComponentDefinition,
    InputComponent,
    LabeledComponentDefinition,
    ValueComponentDefinition,
} from "components/components/Component";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { LabelElement } from "components/components/label/labelElement";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import $ from "jquery";
import { MultivalueElement } from "./components/multivalue";
import template from "./multivalueText.hbs";
import "./multivalueText.scss";

export class MultivalueTextInput extends InputBaseComponent<MultivalueTextInputDefinition> implements InputComponent {
    public static componentType = "multivalueInput";
    private element: MultivalueElement;

    constructor(schema: MultivalueTextInputDefinition) {
        super(schema);
        if (!this.definition.emptyWidth) {
            this.definition.emptyWidth = 0;
        }
        if (this.definition.inputWidth == null) {
            this.definition.inputWidth = 16 - (this.definition.labelWidth || 0) - this.definition.emptyWidth;
        }
        this.definition.labelWidth = this.definition.labelWidth ?? 16;
    }

    public render(): Element {
        let jqueryView = $(template(this.definition));
        this.view = jqueryView[0];
        ComponentActionHelper.register(this);
        this.element = this.view.querySelector("s6-multivalue") as MultivalueElement;
        this.element.addEventListener("change", () => {
            fireDataChangedEvent(this, this.view, this.getValue());
        });
        return this.view;
    }

    public getValue(): Array<string | number> | any {
        return this.element.data;
    }

    public value(v: any) {
        this.element.data = v;
    }
    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string | any) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface MultivalueTextInputDefinition extends LabeledComponentDefinition,
    ValueComponentDefinition,
    ActionComponentDefinition {
    inputWidth?: number;
    emptyWidth?: number;
    isNumeric?: boolean;
}
